module.exports = __webpack_public_path__ + "img/part-9-title.edde78e7.png";